import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrain = (props) => /* @__PURE__ */ _jsxs("svg", {
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	height: "200px",
	width: "200px",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 13a4.5 4.5 0 0 0 3-4" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 18a4 4 0 0 1-1.967-.516" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 13h4" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 18h6a2 2 0 0 1 2 2v1" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 8h8" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 8V5a2 2 0 0 1 2-2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 13,
			r: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 3,
			r: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 21,
			r: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 8,
			r: .5
		})
	]
});
export default SvgBrain;
